import React from "react";
import {
	BulkDeleteButton,
	DateField,
	EditButton,
	List as RaList,
	TextField
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import ImportAllButton from "./buttons/ImportAllButton";
import ResetSyncStatusButton from "./buttons/ResetSyncStatusButton";
import ChannelStatsField from "./fields/ChannelStatsField";
import SettingsField from "./fields/SettingsField";
import StatusField from "./fields/StatusField";
import SyncStatusField from "./fields/SyncStatusField";
import VisibilityField from "./fields/VisibilityField";
import Filters from "./Filters";
import CloneButton from "./inputs/CloneButton";

const BulkActionButtons = (props) => (
	<React.Fragment>
		<ImportAllButton {...props} isButton={true} />
		<ResetSyncStatusButton {...props} />
		<BulkDeleteButton {...props} />
	</React.Fragment>
);

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			perPage={perPage(50, 25)}
			filters={<Filters />}
			sort={{ field: "modified", order: "DESC" }}
			bulkActionButtons={<BulkActionButtons />}
		>
			<ResponsiveList
				mobileHeader={
					<React.Fragment>
						<TextField
							variant="h6"
							source="name"
							style={{ fontWeight: "bold" }}
						/>
						<EditButton />
					</React.Fragment>
				}
				mobileBody={
					<React.Fragment>
						<ChannelStatsField source="channels_stats" sortable={false} />
						<StatusField source="status" />
						<VisibilityField source="visibility" />
						<SyncStatusField source="sync_status" />
						<DateField source="modified" showTime />
					</React.Fragment>
				}
				mobileActions={
					<React.Fragment>
						<SettingsField sortable={false} />
					</React.Fragment>
				}
			>
				<SettingsField sortable={false} />
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<TextField source="name" style={{ fontWeight: "bold" }} />
				<ChannelStatsField source="channels_stats" sortable={false} />
				<StatusField source="status" />
				<VisibilityField source="visibility" />
				<SyncStatusField source="sync_status" />
				<DateField source="modified" showTime />
				<EditButton />
				<CloneButton />
			</ResponsiveList>
		</RaList>
	);
};

export default List;
